import * as api from '../api';

export const generateSitemap = async (set, get) => {
  const { success, failure } = await api.generateSitemap();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Created the new sitemap',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const getRecReview = async (set, get) => {
  const { success, failure } = await api.getRecReview();
  if (failure) {
    return;
  }
  set({ recReview: success }, false, 'getRecReview');
};

/** Search recreation.gov; params { q } or { entity_id }. Sets recSearchResults. */
export const getRecSearch = async (params, set, get) => {
  const { success, failure } = await api.getRecSearch(params);
  if (failure) {
    get().setToast({
      title: failure.message || 'Rec search failed',
      status: 'error',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
    return;
  }
  set({ recSearchResults: success?.results ?? [] }, false, 'getRecSearch');
};

/** Add one outing from rec.gov. Payload: { entity_id } or { outing }. */
export const addRecOuting = async (payload, set, get) => {
  const { success, failure } = await api.addRecOuting(payload);
  if (failure) {
    get().setToast({
      title: failure.message || 'Add failed',
      status: 'error',
      duration: 4000,
      isClosable: true,
      position: 'top',
    });
    return { failure };
  }
  get().setToast({
    title: 'Outing added to database',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
  return { success };
};

export const getCampReview = async (set, get) => {
  const { success, failure } = await api.getCampReview();
  if (failure) {
    return;
  }
  set({ campReview: success }, false, 'getCampReview');
};

export const updatedSafeCamps = async (set, get) => {
  const { success, failure } = await api.updatedSafeCamps();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Updated the camps',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const updatedSafePermits = async (set, get) => {
  const { success, failure } = await api.updatedSafePermits();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Updated the permits',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const updatedSafeOutings = async (set, get) => {
  const { success, failure } = await api.updatedSafeOutings();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Updated the outings',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const updatePermalinks = async (set, get) => {
  const { success, failure } = await api.updatePermalinks();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Added permalink',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const addYSLodges = async (set, get) => {
  const { success, failure } = await api.addYSLodges();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Added the Yellowstone links',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const addGCLodges = async (set, get) => {
  const { success, failure } = await api.addGCLodges();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Added the Grand Canyon links',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const syncTourSlots = async (set, get) => {
  const { success, failure } = await api.syncTourSlots();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Tour Slots Synced',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const syncBrevo = async (set, get) => {
  const { success, failure } = await api.syncBrevo();
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Brevo Sync Started',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const saveRecReview = async ({ outing, recOuting }, set, get) => {
  const { success, failure } = await api.saveRecReview({ outing, recOuting });
  if (failure) {
    return;
  }
};

export const getPermitMapping = async ({ page, size }, set, get) => {
  const { success, failure } = await api.getPermitMapping({ page, size });
  if (failure) {
    return;
  }
  set({ permitMapping: success.permitMapping });
};

export const updatePermit = async ({ permit, crawlerType }, set, get) => {
  const { success, failure } = await api.updatePermit({ permit, crawlerType });
  if (failure) {
    return;
  }
  get().setToast({
    title: 'Updated Permit',
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const updateOffer = async ({ emails }, set, get) => {
  const { success, failure } = await api.updateOffer({ emails });
  if (failure) {
    return;
  }
  get().setToast({
    title: `${success.updateCount} Emails added`,
    status: 'success',
    duration: 2000,
    isClosable: true,
    position: 'top',
  });
};

export const getDashData = async (set, get) => {
  const timeZone =
    typeof Intl !== 'undefined'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : 'UTC';
  const { success, failure } = await api.getDashData({ timeZone });
  if (failure) {
    return;
  }
  set({
    dashData: success,
  });
};

export const getAdTraffic = async (set, { fresh } = {}) => {
  const timeZone =
    typeof Intl !== 'undefined'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : 'UTC';
  set({ adTrafficLoading: true });
  const { success, failure } = await api.getAdTraffic({
    timeZone,
    ...(fresh ? { fresh: '1' } : {}),
  });
  if (failure) {
    set({ adTrafficLoading: false, adTraffic: { error: true } });
    return;
  }
  set({ adTrafficLoading: false, adTraffic: success });
};

export const getFunnelData = async (set, get, range = '30d') => {
  set({ funnelDataLoading: true });
  const { success, failure } = await api.getFunnelData(
    range ? { range } : {}
  );
  set({ funnelDataLoading: false });
  if (failure) {
    return;
  }
  set({ funnelData: success?.funnelData ?? null });
};
